import Grid from "components/Grid";
import Text from "components/Text";
import { routeConstants } from "constants/routeConstants";
import { FC } from "react";
import { TbRuler2 } from "react-icons/tb";
import { useAppSelector } from "slice";
import CardTitle from "../CardTitle";
import {
    Bullet,
    BulletColumn,
    CardWrapper,
    Label,
} from "../PersonalInfo/PersonalInfo.styled";

export const PhysicalDetails: FC = () => {
    const { physical_detail } = useAppSelector((state) => state.user);
    const {
        bust,
        ethnicity,
        eye_color,
        genres,
        hair_color,
        hair_length,
        height,
        hips,
        piercings,
        tattoos,
        waist,
        weight,
    } = physical_detail || ({} as PhysicalDetails);

    const hasSomeData = [
        bust,
        ethnicity,
        eye_color,
        genres,
        hair_color,
        hair_length,
        height,
        hips,
        piercings,
        tattoos,
        waist,
        weight,
    ].some((val) => {
        return val !== "" && val !== null && val !== undefined;
    });

    return (
        <CardWrapper>
            <CardTitle
                icon={<TbRuler2 />}
                title="Physical Details"
                editRoute={
                    routeConstants.profile.editProfile.root +
                    routeConstants.profile.editProfile.physicalDetails
                }
            />
            {hasSomeData ? (
                <>
                    {(height || weight) && (
                        <Grid
                            row={true}
                            expanded
                            justify="flex-start"
                            columnGap={1}
                            marginTop={1}
                        >
                            {height && (
                                <BulletColumn>
                                    <Label variant="body2">Height</Label>
                                    <Bullet>
                                        <Text variant="body2">{height} cm</Text>
                                    </Bullet>
                                </BulletColumn>
                            )}
                            {weight && (
                                <BulletColumn>
                                    <Label variant="body2">Weight</Label>
                                    <Bullet>
                                        <Text variant="body2">{weight} kg</Text>
                                    </Bullet>
                                </BulletColumn>
                            )}
                        </Grid>
                    )}
                    {(hips || waist || bust) && (
                        <Grid
                            row={true}
                            expanded
                            justify="flex-start"
                            columnGap={1}
                            marginTop={1}
                        >
                            <BulletColumn>
                                <Label variant="body2">Hips</Label>
                                <Bullet>
                                    <Text variant="body2">{hips} cm</Text>
                                </Bullet>
                            </BulletColumn>
                            <BulletColumn>
                                <Label variant="body2">Waist</Label>
                                <Bullet>
                                    <Text variant="body2">{waist} kg</Text>
                                </Bullet>
                            </BulletColumn>
                            <BulletColumn>
                                <Label variant="body2">Bust</Label>
                                <Bullet>
                                    <Text variant="body2">{bust} cm</Text>
                                </Bullet>
                            </BulletColumn>
                        </Grid>
                    )}
                    {(eye_color || hair_color || hair_length) && (
                        <Grid
                            row={true}
                            expanded
                            justify="flex-start"
                            columnGap={1}
                            marginTop={1}
                        >
                            <BulletColumn>
                                <Label variant="body2">Eye color</Label>
                                <Bullet>
                                    <Text variant="body2">{eye_color}</Text>
                                </Bullet>
                            </BulletColumn>
                            <BulletColumn>
                                <Label variant="body2">Hair Color</Label>
                                <Bullet>
                                    <Text variant="body2">{hair_color}</Text>
                                </Bullet>
                            </BulletColumn>
                            <BulletColumn>
                                <Label variant="body2">Hair Length</Label>
                                <Bullet>
                                    <Text variant="body2">{hair_length}</Text>
                                </Bullet>
                            </BulletColumn>
                        </Grid>
                    )}
                    {(piercings || genres || ethnicity || tattoos) && (
                        <Grid
                            row={true}
                            expanded
                            justify="flex-start"
                            columnGap={1}
                            marginTop={1}
                        >
                            <BulletColumn>
                                <Label variant="body2">Piercings</Label>
                                <Bullet>
                                    <Text variant="body2">{piercings}</Text>
                                </Bullet>
                            </BulletColumn>

                            <BulletColumn>
                                <Label variant="body2">Ethnicity</Label>
                                <Bullet>
                                    <Text variant="body2">{ethnicity}</Text>
                                </Bullet>
                            </BulletColumn>
                            <BulletColumn>
                                <Label variant="body2">Tattoos</Label>
                                <Bullet>
                                    <Text variant="body2">{tattoos}</Text>
                                </Bullet>
                            </BulletColumn>
                        </Grid>
                    )}
                </>
            ) : (
                <Grid row={true} marginBottom={1} marginTop={1}>
                    <Text variant="body2">No Data Found.</Text>
                </Grid>
            )}
        </CardWrapper>
    );
};
